/**
 * EDS color types
 */
export enum EdsColorType {
  SUCCESS = '#5CCE88',
  ALERT = '#E65867',
  INFO = '#4EC8DD',
  WARNING = '#FFBF5F',
}
